
import { useState } from 'react';
import { Send } from 'lucide-react';
import { ProductCard } from '../ProductCard';
import { toast } from '../ui/use-toast';

interface ChatInputProps {
  onSubmit: (message: string) => void;
  isLoading: boolean;
}

export const ChatInput = ({ onSubmit, isLoading }: ChatInputProps) => {
  const [input, setInput] = useState('');
  const [showTestCard, setShowTestCard] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!input.trim() || isLoading) return;

    if (input.trim() === '/test') {
      setShowTestCard(true);
      setInput('');
      toast({
        title: "Test Mode",
        description: "Showing example product card with competitive listings",
      });
      return;
    }

    onSubmit(input.trim());
    setInput('');
    setShowTestCard(false);
  };

  const exampleProduct = {
    id: 'test-1',
    name: '2017 Lexus RX 350 F Sport',
    description: 'Luxury SUV with advanced safety features, premium audio system, and comfortable leather seating. Well-maintained with regular service history.',
    imageUrl: '/placeholder.svg',
    price: '$27,995',
    link: 'https://example.com/car',
    specifications: {
      year: '2017',
      make: 'Lexus',
      model: 'RX 350',
      trim: 'F Sport',
      mileage: 69755,
    },
    competitiveListings: [
      {
        dealerName: 'Lexus of Towson',
        mileage: 69755,
        price: 26436,
        link: 'https://example.com/listing1',
        reviews: {
          rating: 4.8,
          totalReviews: 128
        }
      },
      {
        dealerName: 'DARCARS Lexus Of Silver Spring',
        mileage: 67052,
        price: 29998,
        link: 'https://example.com/listing2',
        reviews: {
          rating: 4.6,
          totalReviews: 95
        }
      },
      {
        dealerName: 'Pohanka Honda',
        mileage: 123852,
        price: 21800,
        link: 'https://example.com/listing3',
        reviews: {
          rating: 4.4,
          totalReviews: 156
        }
      }
    ]
  };

  return (
    <>
      {showTestCard && (
        <div className="max-w-xl mx-auto mb-4">
          <ProductCard product={exampleProduct} />
        </div>
      )}
      <form onSubmit={handleSubmit} className="chat-input-container">
        <div className="max-w-3xl mx-auto flex gap-3">
          <input
            type="text"
            value={input}
            onChange={(e) => setInput(e.target.value)}
            placeholder={isLoading ? "Please wait..." : "Type /test to see example card, or ask about any car..."}
            className="chat-input"
            disabled={isLoading}
            autoComplete="off"
          />
          <button
            type="submit"
            disabled={isLoading || !input.trim()}
            className="chat-submit-button"
            aria-label="Send message"
          >
            {isLoading ? (
              <div className="h-5 w-5 border-2 border-white/30 border-t-white rounded-full animate-spin" />
            ) : (
              <Send className="h-4 w-4" />
            )}
          </button>
        </div>
      </form>
    </>
  );
};
